<template>
  <div class="our-story">
    <AppNavbar active-tab="OurStory" theme="dark" />

    <!-- Hero Section with city background -->
    <section class="hero">
      <img class="hero-bg" src="@/assets/OurStory/head.png" alt="" />
      <div class="hero-inner">
        <h1 class="hero-title">
          <span class="bracket bracket-tl"></span>
          Our Story
          <span class="bracket bracket-br"></span>
        </h1>

        <img class="quote-mark" src="@/assets/OurStory/quote-mark.png" alt="" />

        <div class="cards-wrap">
          <!-- Right dark card (behind) -->
          <div class="ai-card">
            <h2 class="ai-title">Multimodal 300+ AI<br />alignment analyze</h2>
            <div class="ai-stats">
              <div class="ai-stat">
                <div class="ai-stat-label">Negative emotional characteristics</div>
                <div class="ai-stat-num">36</div>
              </div>
              <div class="ai-stat">
                <div class="ai-stat-label">Personality traits</div>
                <div class="ai-stat-num">270+</div>
              </div>
              <div class="ai-stat">
                <div class="ai-stat-label">Business label system</div>
                <div class="ai-stat-num">200+</div>
              </div>
            </div>
          </div>

          <!-- Left white card (front) -->
          <div class="info-card">
            <div class="info-text">
              Deeply cultivating the field of "emotional computing+AI hardware" and building one of the world's leading Chinese handwriting emotion databases.
            </div>
            <div class="info-text">
              After 4 years of research and development, we have built a million level real handwriting sample library, relying on our self-developed "deep learning algorithm+projection and dynamic typing theory" dual engine,
            </div>
            <div class="info-text">
              Creating an AI smart pen that goes beyond just writing, collecting daily writing data without feeling, and achieving emotional and behavioral analysis.
            </div>
            <div class="stats-row">
              <div class="stat">
                <div class="stat-num">3 age groups</div>
                <div class="stat-label">Handwriting sample coverage</div>
              </div>
              <div class="stat">
                <div class="stat-num">40K+</div>
                <div class="stat-label">Special handwriting samples</div>
              </div>
              <div class="stat">
                <div class="stat-num">20+</div>
                <div class="stat-label">Industry classification label</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Story Content -->
    <section class="story-content">
      <div class="content-inner">
        <h2 class="chapter-title">
          <span class="chapter-label">Chapter 1:</span>The Wake-Up Call
        </h2>
        <p class="story-text">
          So we built one—not as another smart pen, but as a quiet partner. It listens through your writing—turning messy notes into text, yes, but also sensing shifts in your stress, focus, and flow. No screen, no pings, just writing, refined and reflected back to you with gentle awareness.
        </p>
        <p class="story-text">
          We kept it simple because writing is thinking. Typing is fast, but writing is deep. This pen protects that depth, while quietly caring for the person behind the pen.
        </p>

        <h2 class="chapter-title">
          <span class="chapter-label">Part 2:</span>More Than a Smart Pen. It's a Mindful Friend.
        </h2>
        <p class="story-text">
          So we built one—not as another smart pen, but as a quiet partner. It listens through your writing—turning messy notes into text, yes, but also sensing shifts in your stress, focus, and flow. No screen, no pings, just writing, refined and reflected back to you with gentle awareness.
        </p>
        <p class="story-text">
          We kept it simple because writing is thinking. Typing is fast, but writing is deep. This pen protects that depth, while quietly caring for the person behind the pen.
        </p>

        <h2 class="chapter-title">
          <span class="chapter-label">Chapter 3:</span>Writing with Purpose. Join Our Journey.
        </h2>
        <p class="story-text">
          Today, we're still busy—but our goal's changed. We don't just talk about "making things better" with AI anymore. Now we care about "healing" and "seeing how you feel." This pen is our first step. It holds the heart of 1,000 years of writing, plus the care of modern tech. The best human-machine teamwork isn't cold—it's understanding. Every stroke you write is a thought, and every word is a piece of how you feel. We want that quiet conversation you have with yourself, when you write, to be heard. That's why we made this pen. And we want you to join us—to make writing mean more, again.
        </p>
      </div>
    </section>

    <!-- Video Section -->
    <section class="video-section">
      <div class="video-wrap">
        <!-- <video
          ref="videoRef"
          class="video-player"
          :src="videoUrl"
          preload="metadata"
          playsinline
          :controls="playing"
          controlsList="nodownload"
          @ended="playing = false"
          @pause="playing = false"
          @play="playing = true"
        ></video>
        <div v-if="!playing" class="video-overlay" @click="togglePlay">
          <img class="play-btn" src="@/assets/OurStory/play.png" alt="Play" />
          <span class="play-text">2mins get to know about us</span>
        </div> -->

        <div v-if="!playing" class="video-overlay">
          <img class="play-btn" src="@/assets/OurStory/play.png" alt="Play" />
          <span class="play-text">2mins get to know about us</span>
        </div>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'OurStory',
  components: { AppNavbar, AppFooter },
  data() {
    return {
      videoUrl: '',
      // videoUrl: 'https://miaobee.com/miaobiAdmin/api/share/getStream?uuid=25687696-2944-4cee-bcbf-adc3453b0062',
      playing: false
    }
  },
  methods: {
    togglePlay() {
      if (!this.videoUrl) return
      const video = this.$refs.videoRef
      if (this.playing) {
        video.pause()
        this.playing = false
      } else {
        video.play()
        this.playing = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.our-story {
  background: #f5f5f5;
}

// ========== Hero ==========
.hero {
  position: relative;
  width: 100%;
  background: #f5f5f5;
  z-index: 2; // dark card overflows below hero image, must paint above story-content
}

.hero-bg {
  display: block;
  width: 100%;
  height: auto;
}

.hero-inner {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0 12.5% 0;
  box-sizing: border-box;
}

.hero-title {
  font-size: 3.75vw;
  color: #fff;
  margin: 0 0 5.2vw;
  position: relative;
  display: inline-block;
  line-height: 1.2;
  padding: 0.52vw 1.25vw;
}

.bracket {
  position: absolute;
  width: 2.3vw;
  height: 2.3vw;
  border-color: #fff;
  border-style: solid;

  &.bracket-tl {
    top: 0;
    left: 0;
    border-width: 0.5208vw 0 0 0.5208vw;
  }
  &.bracket-br {
    bottom: -0.2604vw;
    right: -0.2604vw;
    border-width: 0 0.5208vw 0.5208vw 0;
  }
}

.quote-mark {
  display: block;
  height: 3.8542vw;
  width: auto;
  margin: 0 0 -1.9792vw;
  position: relative;
  z-index: 3;
}

// Cards container — dark card overflows ~128px below image
.cards-wrap {
  position: relative;
  height: 24.69vw;
}

// White card — design: width 858, height 442, top 85
.info-card {
  position: absolute;
  top: 4.43vw;
  left: 0;
  width: 44.69vw;
  height: 23.02vw;
  background: #fff;
  border-radius: 0.83vw;
  padding: 2.5vw 2.08vw 2.3vw;
  box-sizing: border-box;
  z-index: 2;
}

.info-text {
  font-weight: 400;
  font-size: 1.04vw;
  color: #454545;
  line-height: 1.51vw;
  margin: 0 0 0.73vw;

  &:last-of-type {
    margin-bottom: 2vw;
  }
}

.stats-row {
  display: flex;
  margin-top: 1.5625vw;
  justify-content: space-between;
}

.stat-num {
  font-weight: 500;
  font-size: 1.88vw;
  color: #3c1482;
  line-height: 2.71vw;
  margin-bottom: 0.31vw;
  white-space: nowrap;
}

.stat-label {
  font-size: 0.83vw;
  color: #191919;
  line-height: 1.25vw;
  white-space: nowrap;
}

// Dark card — design: width 1314, height 422, top 180, left 366
.ai-card {
  position: absolute;
  top: 9.38vw;
  left: 6.56vw;
  width: 68.44vw;
  height: 21.98vw;
  background: linear-gradient(180deg, #06030b 0%, #34264c 100%);
  border-radius: 1.25vw;
  padding: 2vw 2.92vw 2vw 41.8vw;
  box-sizing: border-box;
  color: #fff;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ai-title {
  font-size: 2.4vw;
  font-weight: 700;
  margin: 0 0 2.6vw;
  line-height: 1.4;
}

.ai-stats {
  display: grid;
  grid-template-columns: 16.5vw 1fr;
  column-gap: 0.6vw;
  row-gap: 2.6vw;
}

.ai-stat-label {
  font-size: 0.78vw;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 0.42vw;
  white-space: nowrap;
}

.ai-stat-num {
  font-size: 1.88vw;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

// ========== Story Content ==========
.story-content {
  position: relative;
  background: #f5f5f5;
  padding: 7vw 12.5% 2.5vw;
}

.content-inner {
  width: 100%;
}

.chapter-title {
  font-size: 2.5vw;
  font-weight: 700;
  margin: 7vw 0 1.67vw; // 标题与正文间距: 1920 下 32px
  line-height: 1.4;
  text-align: center;
  background: linear-gradient(90deg, #10aa32 0%, #07040d 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.story-text {
  font-size: 0.94vw;
  color: #595959;
  line-height: 2;
  margin: 0 0 0.94vw;
  text-align: justify;
}

// ========== Video Section ==========
.video-section {
  background: #f5f5f5;
  padding: 2vw 12.5% 3.65vw;
}

.video-wrap {
  position: relative;
  width: 100%;
  height: 30vw;
  border-radius: 1.25vw;
  overflow: hidden;
  background: #000;
  cursor: pointer;
}

.video-player {
  display: block;
  width: 100%;
  height: auto;
  min-height: 30vw;
}

.video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5vw;
  background-color: rgba(0, 0, 0, 0.5);
  background: url('@/assets/OurStory/video-cover.png') center / cover no-repeat;

  .play-btn {
    width: 4.5vw;
    height: auto;
  }

  .play-text {
    color: #FFFFFF;
    font-size: 2.5vw;
    font-weight: bold;
    line-height: 3.6458vw;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  }
}

// ========== Responsive ==========
@media (max-width: 768px) {
  .hero {
    background: #12294d;
  }
  .hero-inner {
    position: static;
    padding: 24px 20px 40px;
  }
  .hero-title {
    font-size: 34px;
    margin-bottom: 24px;
    padding: 4px 10px;
  }
  .bracket {
    width: 20px;
    height: 20px;

    &.bracket-tl { border-width: 5px 0 0 5px; }
    &.bracket-br { border-width: 0 5px 5px 0; }
  }
  .quote-mark {
    height: 34px;
    margin-bottom: -8px;
  }
  .cards-wrap {
    height: auto;
  }
  .info-card,
  .ai-card {
    position: static;
    width: 100%;
    height: auto;
    padding: 24px 20px;
    border-radius: 12px;
    margin-bottom: 16px;
  }
  .info-text {
    font-size: 14px;
    line-height: 1.8;
    margin-bottom: 12px;

    &:last-of-type { margin-bottom: 20px; }
  }
  .stat-num { font-size: 22px; line-height: 1.3; }
  .stat-label { font-size: 12px; line-height: 1.4; white-space: normal; }
  .ai-title { font-size: 22px; margin-bottom: 20px; }
  .ai-stats {
    grid-template-columns: 1fr 1fr;
    row-gap: 20px;
    column-gap: 16px;
  }
  .ai-stat-label { font-size: 12px; white-space: normal; }
  .ai-stat-num { font-size: 24px; }

  .story-content {
    padding: 40px 20px 24px;
  }
  .chapter-title {
    font-size: 22px;
    margin: 40px 0 16px;
  }
  .story-text {
    font-size: 14px;
    line-height: 1.9;
  }
  .video-section {
    padding: 16px 20px 40px;
  }
  .video-wrap {
    border-radius: 12px;
  }
  .video-player {
    min-height: 200px;
  }
  .video-overlay {
    .play-btn { width: 40px; }
    .play-text { font-size: 15px; }
  }
}
</style>
